<div class="p-2 p-lg-4 container-fluid">
  <h5 class="mt-2">A informação abaixo consta do perfil no Registo Único do IPDJ.</h5>
  <h5>Caso o perfil não esteja atualziado, deve clicar no nome no canto superior direito e depois em Gerir Perfil.</h5>
  <ul #nav="ngbNav" [activeId]="1" class="flex-column flex-sm-row nav nav-fill nav-pills mb-4" ngbNav orientation="horizontal">
    <li [ngbNavItem]="1">
      <a class="flex-sm-fill text-sm-center" ngbNavLink><b>1.</b> Identificação</a>
      <ng-template ngbNavContent>
        <div class="form-row">
          <div class="form-group col-sm">
            <label class="form-control-label" jhiTranslate="app.young.civilStatus">civilStatus</label>
            <p class="form-control-plaintext">{{ 'app.CivilStatus.' + record?.person?.civilStatus | translate }}</p>
          </div>
          <div class="form-group col-sm">
            <label class="form-control-label" jhiTranslate="app.young.sex">sex</label>
            <p class="form-control-plaintext">{{ 'app.Sex.' + record?.person?.sex | translate }}</p>
          </div>
          <div class="form-group col-sm">
            <label class="form-control-label" jhiTranslate="app.young.dateOfBirth">dateOfBirth</label>
            <p class="form-control-plaintext">{{ record?.person?.dateOfBirth }}</p>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-sm">
            <label class="form-control-label" jhiTranslate="app.young.phones">phones</label>
            <p class="form-control-plaintext">
              <span *ngFor="let phone of record?.phones; let last = last">
                {{ phone.phoneNumber }}
                <span *ngIf="phone.extension">({{ phone.extension }})</span>
                <fa-icon *ngIf="phone.preferentialPhone" [icon]="'check-circle'" [appendTo]="'body'" [pTooltip]="'Preferencial'"></fa-icon>
                {{ last ? '' : ',' }}
              </span>
            </p>
          </div>
          <div class="form-group col-sm">
            <label class="form-control-label" jhiTranslate="app.young.emails">phones</label>
            <p class="form-control-plaintext">
              <span *ngFor="let email of record?.emails; let last = last">
                {{ email.email }}
                <fa-icon *ngIf="email.preferentialEmail" [icon]="'check-circle'" [appendTo]="'body'" [pTooltip]="'Preferencial'"></fa-icon>
                {{ last ? '' : ',' }}
              </span>
            </p>
          </div>
          <div class="form-group col-sm">
            <label class="form-control-label">Documentos de Identificação</label>
            <div class="table-responsive">
              <table class="align-items-center table table-flush table-responsive">
                <thead class="thead-light">
                  <tr>
                    <th>Documento</th>
                    <th>N.º Documento</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let sector of getSectorIdentifications()">
                    <td>{{ 'app.CitizenIdentificationNumber.' + sector?.citizenIdentificationNumber | translate }}</td>
                    <td>{{ sector?.identificationNumber }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </ng-template>
    </li>
    <li [ngbNavItem]="2">
      <a class="flex-sm-fill text-sm-center" ngbNavLink><b>2.</b> Moradas</a>
      <ng-template ngbNavContent>
        <div class="table-responsive">
          <table class="align-items-center table table-flush table-responsive">
            <thead class="thead-light">
              <tr>
                <th>Morada</th>
                <th>Código Postal</th>
                <th>Freguesia</th>
                <th>Concelho</th>
                <th>Preferencial</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let portugueseAddress of getPortugueseAddress()">
                <td>
                  <span>
                    {{ portugueseAddress.postalCode?.arteryType }} {{ portugueseAddress.postalCode?.firstPreposition }}
                    {{ portugueseAddress.postalCode?.arteryTitle }} {{ portugueseAddress.postalCode?.secondPreposition }}
                    {{ portugueseAddress.postalCode?.arteryDesignation }} {{ portugueseAddress.postalCode?.arteryInformation }}
                    {{ portugueseAddress.door && portugueseAddress.door.trim().length > 0 ? ' nº ' : '' }}{{ portugueseAddress.door }}
                    {{ portugueseAddress.floor }} {{ portugueseAddress.side }} {{ portugueseAddress.site }}</span
                  >
                </td>
                <td>
                  <span *ngIf="portugueseAddress.postalCode?.codeNumber"
                    >{{ portugueseAddress.postalCode?.codeNumber }} -{{ portugueseAddress.postalCode?.codeExtension }}</span
                  >
                </td>
                <td>
                  {{ portugueseAddress.locality }}
                </td>
                <td>{{ portugueseAddress.postalLocality }}</td>
                <td>
                  <fa-icon *ngIf="portugueseAddress.preferential" [fixedWidth]="true" icon="check"></fa-icon>
                  <fa-icon *ngIf="!portugueseAddress.preferential" [fixedWidth]="true" icon="times"></fa-icon>
                </td>
              </tr>
              <!--                            <tr *ngFor="let foreignAddress of getForeignAddress()">-->
              <!--                                <td>{{foreignAddress.postalCode}}</td>-->
              <!--                                <td>{{foreignAddress.locality}}</td>-->
              <!--                                <td>{{foreignAddress.countryId}}</td>-->
              <!--                                <td>-->
              <!--                                    <fa-icon *ngIf="foreignAddress.preferential" [fixedWidth]="true"-->
              <!--                                             icon="check"></fa-icon>-->
              <!--                                    <fa-icon *ngIf="!foreignAddress.preferential" [fixedWidth]="true"-->
              <!--                                             icon="times"></fa-icon>-->
              <!--                                </td>-->
              <!--                            </tr>-->
            </tbody>
          </table>
        </div>
      </ng-template>
    </li>
    <li [ngbNavItem]="3">
      <a class="flex-sm-fill text-sm-center" ngbNavLink><b>3.</b> Instituições</a>
      <ng-template ngbNavContent>
        <div class="table-responsive">
          <table class="align-items-center table table-flush table-responsive">
            <thead class="thead-light">
              <tr>
                <th>Designação</th>
                <th>N.º Contribuinte</th>
                <th>Distrito</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let record of getInstitutions()">
                <td>{{ record?.institution?.designation }}</td>
                <td>{{ record?.institution?.corporateTaxpayerNumber }}</td>
                <td>{{ 'app.District.' + record?.institution?.locationAuthority | translate }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav"></div>
</div>
